import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, Tooltip, useTheme } from "@mui/material";

import PostCard from "../../components/PostCard";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store";
import { useCallback, useEffect, useState } from "react";
import {setApprovedPosts, setPostsLoading, setPostsResponse, setResetPost } from "../../store/slices/posts";
import BirthdaysCard from "./BirthdaysCard";
import RecognitionCard from "./RecognitionCard";
import { useLocation } from "react-router-dom";
import ThreeComponent from "../../components/ThreeColumnsComponent";
import MySnackbar from "../../components/MySnackbar";

import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';

import { ApprovePostRequest, UnaprovePostData } from "../../interfaces/post.interface";
import { deletePostsRequest, getUnApprovedPostsRequest, setApprovePostRequest } from "../../api/employeePortal";
import DeleteIcon from '@mui/icons-material/Delete';


const ThreeColumnsPosts = () => {

    const location = useLocation();
    const dispatch = useDispatch<AppDispatch>();
    const {companyselected} = useSelector((state: RootState) => state.auth);
    const {loadingPosts, posts} = useSelector((state: RootState) => state.posts);
    const postsState = useSelector((state: RootState) => state.posts);
    const [errorMsg, setErrorMsg] = useState("")
    const [successMsg, setSuccessMsg] = useState("")
    const [postData, setPostData] = useState<UnaprovePostData | null>(null);
    const [deleteDocument, setDeleteDocument] = useState<any | null>(null);
    const [loading, setLoading] = useState(false)


    useEffect(() => {
        if (companyselected?.Code && !postsState.loadingPosts) {
            dispatch(setPostsLoading(true))
            dispatch(setPostsResponse({postType: 'unapprovedPost', response: {Items: [], nextPageB64: ""}}));
            getPosts();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [companyselected?.Code])

  
    const ComponentOne = useCallback(() => (
        <BirthdaysCard title="Cumpleaños" onlyList={true} hidenButton={true} />
    ), []);

  
    const ComponentTwo = useCallback(() => (
        <RecognitionCard onlyList={true} hidenButton={true}/>
    ), []);
    
    const getPosts = async () => {
        if (!companyselected?.Token || loadingPosts) {
            return
        }
        const result = await getUnApprovedPostsRequest({postType: 'unapprovedPost'});
        dispatch(setPostsLoading(false))
        if (result?.status !== 200) {
            const msg = typeof result.data === "string" ? result.data : "No fue posible obtener los posts."
            console.error(result)
            setErrorMsg(msg)
            return;
        }
        dispatch(setPostsResponse({postType: 'unapprovedPost', response: result.data.message}));
    }
    
    const handleSetApprovalStatuses = async (postData: UnaprovePostData, approvalStatus: ApprovePostRequest['approvalStatus']) => {
        if (loadingPosts) {
            return;
        }
        const data: ApprovePostRequest = {
            approvalStatus,
            postType: postData.postType,
            orderTimestamp: postData.orderTimestamp,
        }
        console.log("request data", data)
        const result = await setApprovePostRequest(data);
        dispatch(setPostsLoading(false))
        console.log("request response", result)
        if (!result || result?.status !== 200) {
            const msg = typeof result?.data === "string" ? result.data : "Error actualizando la publicación."
            setErrorMsg(msg);
            return;
        }
        dispatch(setApprovedPosts({id: postData.postId, newStatus: approvalStatus}));
        setSuccessMsg("Publicación actualizada.")
    }

    const handleDeletePost = async () => {
        if (loadingPosts) {
            return;
        }
        const data = {
            ...deleteDocument,
            postType: "unapprovedPost",
            orderTimestamp: deleteDocument.orderTimestamp,
            "orderTimestamp-ID": deleteDocument.orderTimestamp,
        }
        setLoading(true)
        const result = await deletePostsRequest(data);
        if (result?.status === 200) {
            dispatch(setResetPost("unapprovedPost"));
            setSuccessMsg("El documento fue eliminado con éxito")
            await getPosts();
            setDeleteDocument(null);
        } else {
            console.log(result)
            setErrorMsg(result?.data?.message || "Ocurrio un error al eliminar el documento, por favor reintenta")
        }
        setLoading(false)
    }
    
    const HandlePostActions = ({row}: {row: UnaprovePostData}) => {
        const theme = useTheme();
        const [loading, setLoading] = useState(false)
        return (<Grid container direction="row" minWidth="8rem">

            <Tooltip
                title="Ver"
                slotProps={{
                popper: {
                    modifiers: [
                    {
                        name: 'offset',
                        options: {
                        offset: [0, -14],
                        },
                    },
                    ],
                },
                }}
            >
                <IconButton
                    disabled={loadingPosts || loading}
                    aria-label="Ver documento"
                    onClick={() => setPostData(row as any)}
                    style={{
                        // border: "1px solid #159D65",
                        // background: "#E8F7F1",
                        color: theme.s10palette.S10Blueblue700,
                        minWidth: "2rem",
                        minHeight: "2rem",
                        padding: ".25rem",
                        marginLeft: ".5rem",
                        // marginRight: "1.5rem"
                    }}
                >
                    {loading || loadingPosts
                        ? <CircularProgress color="primary" size="1rem" />
                        : <RemoveRedEyeOutlinedIcon />
                    }
                </IconButton >
            </Tooltip>
            <Tooltip
                title="Aprobar"
                slotProps={{
                popper: {
                    modifiers: [
                    {
                        name: 'offset',
                        options: {
                        offset: [0, -14],
                        },
                    },
                    ],
                },
                }}
            >
                <IconButton
                    disabled={loadingPosts || loading}
                    aria-label="Aprobar"
                    onClick={async () => {
                        setLoading(true)
                        await handleSetApprovalStatuses(row as any, "approved")
                        setLoading(false)
                    }}
                    style={{
                        // border: "1px solid #159D65",
                        // background: "#E8F7F1",
                        color: theme.s10palette.S10Blueblue700,
                        minWidth: "2rem",
                        minHeight: "2rem",
                        padding: ".25rem",
                        marginLeft: ".5rem",
                        // marginRight: "1.5rem"
                    }}
                >
                    {loading || loadingPosts
                        ? <CircularProgress color="primary" size="1rem" />
                        : <CheckIcon color="success" />
                    }
                </IconButton >
            </Tooltip>
            {row.approvalStatus !== "rejected" && <Tooltip
                title="Rechazar"
                slotProps={{
                popper: {
                    modifiers: [
                    {
                        name: 'offset',
                        options: {
                        offset: [0, -14],
                        },
                    },
                    ],
                },
                }}
            >                
                <IconButton
                    disabled={loadingPosts || loading}
                    aria-label="rechazar"
                    onClick={async () => {
                        setLoading(true)
                        await handleSetApprovalStatuses(row as any, "rejected");
                        setLoading(false)
                    }}
                    style={{
                        // border: "1px solid #159D65",
                        // background: "#E8F7F1",
                        color: theme.s10palette.S10Blueblue700,
                        minWidth: "2rem",
                        minHeight: "2rem",
                        padding: ".25rem",
                        marginLeft: ".5rem",
                        // marginRight: "1.5rem"
                    }}
                >
                    {loading || loadingPosts
                        ? <CircularProgress color="primary" size="1rem" />
                        : <CloseIcon color="error" />
                    }
                </IconButton >
            </Tooltip>}
            <Tooltip
                title="Eliminar"
                slotProps={{
                popper: {
                    modifiers: [
                    {
                        name: 'offset',
                        options: {
                        offset: [0, -14],
                        },
                    },
                    ],
                },
                }}
            >                
                <IconButton
                    disabled={loadingPosts || loading}
                    aria-label="eliminar"
                    onClick={async () => {
                        setDeleteDocument(row);
                    }}
                    style={{
                        // border: "1px solid #159D65",
                        // background: "#E8F7F1",
                        color: theme.s10palette.S10Blueblue700,
                        minWidth: "2rem",
                        minHeight: "2rem",
                        padding: ".25rem",
                        marginLeft: ".5rem",
                        // marginRight: "1.5rem"
                    }}
                >
                    {loading || loadingPosts
                        ? <CircularProgress color="primary" size="1rem" />
                        : <DeleteIcon color="error" />
                    }
                </IconButton >
            </Tooltip>
        </Grid>)
    }
  
    const ComponentThree = useCallback(() => (
        <>
            <Grid container item 
                // style={{paddingLeft: "1.5rem", paddingRight: "1.5rem"}}
                // sx={{p: {xs: 0, md: "0 1.5rem"}}}
                xs={12}
                justifyContent={"center"} 
                alignContent={"start"} 
            >
                {posts.data?.map((post) => (
                    <Grid 
                        key={post.postId}
                        container
                        style={{margin: "0 0 1.5rem 0"}}
                    >
                        <PostCard postData={post} setErrorMsg={() => {}} setSuccessMsg={() => {}} onlyView={true} />
                        <HandlePostActions row={post as UnaprovePostData} />
                    </Grid>
                ))}
                
            </Grid>
        </>
    // eslint-disable-next-line react-hooks/exhaustive-deps
    ), [posts]);

    return (

        <Grid key={location.pathname} container spacing="1rem" >
            <ThreeComponent
                tabsTitle={["Cumpleaños", "Reconocimientos", "Comunicados"]}
                excludeTitleToComponents={[0, 1]}
                excludeCardsToComponents={[0, 1]}
                useTabsNameAsTitle={true}
                ComponentOne={ComponentOne}
                ComponentTwo={ComponentTwo}
                ComponentThree={ComponentThree}
            />
            {postData && <Dialog
                open={postData !== null}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogContent style={{width: "100%", height: "50%", padding: "0 1.5rem", textAlign: "center"}}>
                    <PostCard
                        postData={postData} 
                        setErrorMsg={() => {}} 
                        setSuccessMsg={() => {}}
                        disableElevation={true}
                        onlyView={true}
                    />
                </DialogContent>
                <DialogActions>
                    <Grid container>
                    <Grid item margin={"1.5rem 1.5rem 2.5rem 1.5rem"} padding={0} textAlign="center" xs={12}>
                        <Button
                            variant="contained" 
                            style={{width: "8rem"}}
                            startIcon={<CheckIcon style={{height: "1rem"}} />}
                            onClick={() => setPostData(null)}
                        >
                            Aceptar
                        </Button>
                    </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>}
            {errorMsg && <MySnackbar
                severity="error"
                msg={errorMsg}
                open={true}
                onClose={() => setErrorMsg("")}
            />}
            {successMsg && <MySnackbar
                severity="success"
                msg={successMsg}
                open={true}
                onClose={() => setSuccessMsg("")}
            />}
            {deleteDocument && 
                <Dialog
                    open={!!deleteDocument}
                    aria-labelledby="responsive-dialog-title"
                >
                    <DialogTitle
                        id="responsive-dialog-title" 
                        style={{textAlign: "center"}} 
                        variant="h5"
                    >
                        ¿Seguro de eliminar la publicación seleccionada?
                    </DialogTitle>
                    <DialogContent style={{width: "100%", height: "50%", padding: "0 1.5rem", }}>
                        Esta acción no se puede revertir.
                    </DialogContent>
                    <DialogActions>
                        <Grid container direction="row" marginTop="1rem">
                        <Grid item xs={6}>
                            <Button 
                                variant="outlined" 
                                style={{width: "8rem", margin: ".5rem",}}
                                startIcon={<CloseIcon style={{height: "1rem"}} />}
                                onClick={() => setDeleteDocument(null)}
                            >
                                Cancelar
                            </Button>
                        </Grid>
                        <Grid item xs={6} textAlign={"right"}>
                            <Button
                                variant="contained" 
                                style={{width: "8rem", margin: ".5rem",}}
                                startIcon={<CheckIcon style={{height: "1rem"}} />}
                                onClick={handleDeletePost}
                                disabled={loading}
                            >
                                Aceptar
                            </Button>
                        </Grid>
                        </Grid>
                    </DialogActions>
                </Dialog>
            }
        </Grid>
    );
}

export default ThreeColumnsPosts;